import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import MuiChip, { ChipProps } from '@material-ui/core/Chip';

const Subcategory: React.FC<ChipProps> = withStyles((theme) => ({
  root: {
    backgroundColor: '#FED278',
  },
  labelSmall: {
    maxWidth: 60,
    fontSize: theme.typography.pxToRem(12),
    paddingLeft: 8,
    paddingRight: 8,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 100,
      paddingLeft: 12,
      paddingRight: 12,
    },
  },
  sizeSmall: {
    [theme.breakpoints.only('xs')]: {
      height: 20,
    },
  },
}))(MuiChip);

export default Subcategory;
